import { useEffect, useState, useCallback } from "react";
import { Grid } from '@mui/joy';
import Paginations from "../../component/Pagination";
import PastJobsCard from "../card/fundi/PastJobsCard";

export default function ActiveJobPaginate() {
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(4);
    const [books, setBooks] = useState([]);
    const [loading, setLoading] = useState(false);

    const [pageNumberLimit, setPageNumberLimit] = useState(5);
    const [minPageNumberLimit, setMinPageNumberLimit] = useState(0);
    const [maxPageNumberLimit, setMaxPageNumberLimit] = useState(5);

    const changePage = useCallback((pageNumber) => {
        setPage(pageNumber);
    }, []);

    const incrementPage = useCallback(() => {
        setPage((prev) => {
            const newPage = prev + 1;
            if (newPage > maxPageNumberLimit) {
                setMaxPageNumberLimit((prev) => prev + pageNumberLimit);
                setMinPageNumberLimit((prev) => prev + pageNumberLimit);
            }
            return newPage;
        });
    }, [maxPageNumberLimit, pageNumberLimit]);

    const decrementPage = useCallback(() => {
        setPage((prev) => {
            if (prev === 1) return prev;
            const newPage = prev - 1;
            if ((newPage - 1) % pageNumberLimit === 0) {
                setMaxPageNumberLimit((prev) => prev - pageNumberLimit);
                setMinPageNumberLimit((prev) => prev - pageNumberLimit);
            }
            return newPage;
        });
    }, [pageNumberLimit]);

    useEffect(() => {
        const fetchBooks = async () => {
            setLoading(true);
            try {
                const response = await fetch(`http://localhost:8000/api/books?page=${page}&limit=${pageSize}`);
                if (!response.ok) throw new Error("Failed to fetch books");
                const bookList = await response.json();
                setBooks(bookList.books || []);
            } catch (error) {
                console.error("Error fetching books:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchBooks();
    }, [page, pageSize]);

    const totalPages = 20;

    return (
        <main className="py-2">
            <div>
                <Grid container spacing={0} columns={{ xs: 12, sm: 12, md: 12, lg: 12 }} sx={{ flexGrow: 1, width: '100%' }}>
                    {loading ? (
                        <div className="text-2xl font-bold text-center pt-14">Loading...</div>
                    ) : books.length > 0 ? (
                        books.map((data) => (
                            <Grid key={data._id} item xs={12} sm={6} md={6} lg={6} sx={{ marginTop: '2rem', marginBottom: '3rem' }}>
                                <PastJobsCard book={data} />
                            </Grid>
                        ))
                    ) : ''}
                </Grid>

                <Paginations
                    totalPages={totalPages}
                    pageSize={pageSize}
                    page={page}
                    changePage={changePage}
                    incrementPage={incrementPage}
                    decrementPage={decrementPage}
                    pageNumberLimit={pageNumberLimit}
                    minPageNumberLimit={minPageNumberLimit}
                    maxPageNumberLimit={maxPageNumberLimit}
                />
            </div>
        </main>
    );
}
